import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

// Crypto Redux States
import { RolesTypes } from './actionTypes';
import {
  getRolesSuccess,
  getRolesFail,
  addRolesFail,
  addRolesSuccess,
  deleteRolesSuccess,
  deleteRolesFail,
  updateRolesFail,
  updateRolesSuccess,
} from './actions';

import apiFetch from '../../fetch';
import * as url from '../../helpers/url_helper';
import { addApiListSuccessful } from '../apiList/actions';

export const fetchRoles = async (data: any) => {
  const { sizePerPage, page } = data?.pagination ?? {
    sizePerPage: 50,
    page: 1,
  };

  let textName = '';

  if (data.data) {
    textName = data.data['Search Name'];
  }
  const path = url.API_URL;
  const query = `query {
    roles (
        Pagination:{
            sizePage:${sizePerPage},
            actualPage:${page},
        },
        order:"${data?.data?.order ?? "{'id': 'ASC'}"}",
        filter:{
          ${textName ? `nombre: "${textName}"` : ''}
      }
        
        ) {
            rolesData {
              id
              nombre
              version
              descripcion
              MCA_ACTIVO
              MCA_SUPERUSUARIO
              createdAt
              updatedAt
              permisos {
                  id
                  nombre
                  version
                  descripcion
                  url_menu
                  icon      
              }     
            }   
            CountItems
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.roles;
};

function* getRolesSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchRoles, data.payload);
    yield put(getRolesSuccess(response));
  } catch (error) {
    yield put(getRolesFail(error));
  }
}

export const addRolesList = async ({ payload: { rolesAdd } }: any) => {
  const path = url.API_URL;
  const { nombre, version, descripcion, MCA_ACTIVO, MCA_SUPERUSUARIO } =
    rolesAdd.role;
  const query = `mutation{
    createRol(Rol:{
        nombre: "${nombre}",
        version : "${version}",
        descripcion: "${descripcion}",
        MCA_ACTIVO: ${MCA_ACTIVO},
        MCA_SUPERUSUARIO: ${MCA_SUPERUSUARIO}
        
    }){
        id
        nombre
        version
        descripcion
        MCA_ACTIVO
        MCA_SUPERUSUARIO
        createdAt
        updatedAt
      }
    }`;

  const respon = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return respon.data.createRol;
};

function* addRolesSaga(rol: any) {
  const { pagination } = rol.payload.rolesAdd;
  try {
    const response: Promise<any> = yield call(addRolesList, rol);

    yield put(addRolesSuccess(response));
    const response2: Promise<any> = yield call(fetchRoles, { pagination });
    yield put(getRolesSuccess(response2));
  } catch (error) {
    yield put(addRolesFail(error));
  }
}

export const deleteRolesList = async (data: any) => {
  const path = url.API_URL;
  const { id } = data;
  const query = `mutation{
    deleteRol(Rol: {
        id: ${id}
    }){
      nombre
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.deleteRol;
};

function* deleteRolesSaga({ payload }: any) {
  const { id } = payload;
  try {
    const response: Promise<any> = yield call(deleteRolesList, id);
    yield put(deleteRolesSuccess(response));
    const response2: Promise<any> = yield call(fetchRoles, payload);
    yield put(getRolesSuccess(response2));
  } catch (error) {
    yield put(deleteRolesFail(error));
  }
}

function* updateRolesList(action: any): any {
  const path = url.API_URL;
  const { payload } = action;
  const { pagination } = payload.role;
  const { id, nombre, version, descripcion, MCA_ACTIVO, MCA_SUPERUSUARIO } =
    payload.role.role;
  const query = `mutation{
      updateRol(Rol: {
          id: ${id}
          version: "${version}",
          descripcion: "${descripcion}",
          nombre: "${nombre}",
          MCA_ACTIVO: ${MCA_ACTIVO},
          MCA_SUPERUSUARIO: ${MCA_SUPERUSUARIO}
      }){
          id
      }
  }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    const resp: any = yield call(apiFetch, path, opts);

    const response: Promise<any> = yield call(fetchRoles, payload.role);
    yield put(updateRolesSuccess(response));
  } catch (error) {
    yield put(updateRolesFail(error));
  }
}

function* updateRolPermisos(action: any): any {
  const { payload } = action;
  const path = url.API_URL;
  const { id, permissions, clientId } = payload.rol;
  const permissionsFormat = JSON.stringify(permissions);

  const query = `mutation {  
    update_Rol ( Rol:  {
        id: ${Number(id)},
        permisos: ${permissionsFormat.replace(/"/g, '')}
        clientId: ${clientId}
    })    
    {
        id
        permisos{
          id
        }
      }
  }`;
  try {
    const opts = {
      authRequired: false,
      headers: {
        'Content-Type': 'application/json',
      },
      body: {
        query,
      },
      method: 'POST',
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const resp: any = yield call(apiFetch, path, opts);
    if (resp.status === 200) {
      const response: Promise<any> = yield call(fetchRoles, payload.rol);
      yield put(updateRolesSuccess(response));
    } else {
      let textError = '';
      // eslint-disable-next-line array-callback-return
      resp.body.errors.map((item: any) => {
        textError = textError + item.message + ', ';
      });
      yield put(updateRolesFail(textError));
    }
  } catch (error) {
    yield put(updateRolesFail(error));
  }
}

function* RolesSaga() {
  yield takeEvery(RolesTypes.GET_ROLES, getRolesSaga);
  yield takeEvery(RolesTypes.ADD_ROLES, addRolesSaga);
  yield takeEvery(RolesTypes.DELETE_ROLES, deleteRolesSaga);
  yield takeLatest(RolesTypes.UPDATE_ROLES, updateRolesList);
  yield takeLatest(RolesTypes.UPDATE_ROL_PERMISSIONS, updateRolPermisos);
}

export default RolesSaga;
